import React from 'react';

import { Radio } from '@mui/material';

import { IBdsRadioButton } from '../../../interfaces/bdsRadioButton';
import './BdsRadioButton.scss';

const BdsRadioButton = ({ name, value, selected, onChange, variant = 'primary', disabled }: IBdsRadioButton) => {
  const classNames = ['bds-radio-button', variant].join(' ');
  const handleChange = () => {
    if (!disabled) {
      onChange(value);
    }
  };

  return (
    <Radio
      className={classNames}
      checked={selected}
      onChange={handleChange}
      value={value}
      name={name}
      disabled={disabled}
    />
  );
};

export default BdsRadioButton;
